import DocumentTransfertPage from "./DocumentTransfertPage";

const DocumentTransfertAchatPage = () => {
  return <DocumentTransfertPage mode="achat" />;
};

export default DocumentTransfertAchatPage;